export function fetchWithCsrf(url, options = {}) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content

  const defaultHeaders = {
    'X-CSRF-Token': token
  }

  if (!(options.body instanceof FormData)) {
    defaultHeaders['Content-Type'] = 'application/json'
  }

  return fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {})
    }
  })
}
